import { Tab, Tabs, TabsBody, TabsHeader } from "@material-tailwind/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ProfileUpdate from "../../components/Forms/ProfileUpdate";
import ChangePassword from "../../components/Forms/ChangePassword";

export default function Profile() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<number>(0);

    const handleTabChange = (index: number) => {
        setActiveTab(index);
    };

    return (
        <>
            <div>
                <h1 className="mb-4 text-3xl text-[#041B44] h-[40px]">{t("profile.title")}</h1>
            </div>
            <div className="bg-white rounded-2xl min-h-[400px] w-full shadow-sm border border-gray-100 p-4 sm:p-8 flex flex-col">
                <Tabs value={activeTab === 0 ? "Basic" : "Sessions"} className="flex flex-col flex-1">
                    <TabsHeader className="border-b-2 rounded-none mx-0 sm:mx-4 shrink-0 mb-4 flex-nowrap bg-transparent">
                        <Tab
                            key="Basic"
                            value="Basic"
                            onClick={() => handleTabChange(0)}
                            className={`w-auto min-w-[140px] sm:min-w-[180px] px-4 sm:px-6 py-2.5 whitespace-nowrap text-[#B0BEC5] border-b-2 custom-mb-minus-5 ${
                                activeTab === 0 ? "active border-[#0B9ABF]" : ""
                            }`}
                        >
                            {t("profile.personalInfoTab")}
                        </Tab>
                        <Tab
                            key="Sessions"
                            value="Sessions"
                            onClick={() => handleTabChange(1)}
                            className={`w-auto min-w-[140px] sm:min-w-[180px] px-4 sm:px-6 py-2.5 whitespace-nowrap text-[#B0BEC5] border-b-2 custom-mb-minus-5 ${
                                activeTab === 1 ? "active border-[#0B9ABF]" : ""
                            }`}
                        >
                            {t("profile.changePasswordTab")}
                        </Tab>
                    </TabsHeader>

                    <TabsBody className="flex-1">
                        <div className={activeTab === 0 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 0 && <ProfileUpdate />}
                        </div>

                        <div className={activeTab === 1 ? "tab-panel active" : "tab-panel"}>
                            {activeTab === 1 && <ChangePassword />}
                        </div>
                    </TabsBody>
                </Tabs>
            </div>
        </>
    );
}